var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 40,
    viewBox: "0 0 75 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_890_13837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.29411 39.7392C1.56471 39.7392 1 39.5292 0.599998 39.109C0.2 38.689 0 38.1113 0 37.3761V10.634C0 9.89881 0.2 9.32115 0.599998 8.90103C1 8.48097 1.56471 8.27087 2.29411 8.27087C3 8.27087 3.5647 8.48097 3.98823 8.90103C4.41176 9.32115 4.62353 9.89881 4.62353 10.634V11.4216C5.63528 10.3189 6.68235 9.51807 7.76473 9.01918C8.87059 8.52035 10.1176 8.27087 11.5059 8.27087C13.3412 8.27087 14.9412 8.67789 16.3059 9.4918C17.6941 10.3058 18.7529 11.4742 19.4824 12.997C20.2353 14.4936 20.6118 16.266 20.6118 18.314C20.6118 20.3357 20.2353 22.108 19.4824 23.6309C18.7294 25.1538 17.6588 26.3222 16.2706 27.1361C14.8823 27.9501 13.2471 28.357 11.3647 28.357C9.95296 28.357 8.71767 28.1207 7.65884 27.6481C6.60002 27.1493 5.59998 26.3616 4.65882 25.285L4.62353 37.3761C4.62353 38.1113 4.41176 38.689 3.98823 39.109C3.5647 39.5292 3 39.7392 2.29411 39.7392ZM10.4118 24.261C12.1529 24.261 13.5059 23.749 14.4706 22.725C15.4588 21.6748 15.953 20.2044 15.953 18.314C15.953 16.4235 15.4588 14.9663 14.4706 13.9423C13.5059 12.892 12.1529 12.3669 10.4118 12.3669C8.59998 12.3669 7.17647 12.9052 6.1412 13.9816C5.12941 15.0319 4.62353 16.476 4.62353 18.314C4.62353 20.1519 5.12941 21.6092 6.1412 22.6856C7.17647 23.7359 8.59998 24.261 10.4118 24.261ZM34.8998 28.357C34.1704 28.357 33.6057 28.147 33.2057 27.7269C32.8057 27.3068 32.6057 26.7292 32.6057 25.994V10.634C32.6057 9.87254 32.7939 9.29487 33.1704 8.90103C33.5704 8.48097 34.1234 8.27087 34.8292 8.27087C35.5351 8.27087 36.088 8.48097 36.4881 8.90103C36.8881 9.32115 37.0881 9.89881 37.0881 10.634V11.7761C38.7586 9.43931 41.041 8.27087 43.9351 8.27087C46.194 8.27087 47.9704 9.07174 49.2645 10.6733C50.5822 12.2487 51.241 14.4018 51.241 17.1324V25.994C51.241 26.7292 51.0292 27.3068 50.6057 27.7269C50.1822 28.147 49.6175 28.357 48.9116 28.357C48.1822 28.357 47.6175 28.147 47.2175 27.7269C46.8174 27.3068 46.6175 26.7292 46.6175 25.994V17.1324C46.6175 15.6358 46.288 14.4674 45.6292 13.6272C44.9704 12.787 44.0528 12.3669 42.8763 12.3669C41.0881 12.3669 39.6998 12.9576 38.7116 14.1392C37.7234 15.2945 37.2292 16.9224 37.2292 19.0229V25.994C37.2292 26.7292 37.0175 27.3068 36.594 27.7269C36.1704 28.147 35.6057 28.357 34.8998 28.357ZM64.4847 37.8093C62.6494 37.8093 60.9553 37.5074 59.4024 36.9035C57.8726 36.2996 56.6726 35.4725 55.8024 34.4223C55.4726 34.0284 55.3083 33.5821 55.3083 33.0832C55.3083 32.4268 55.5906 31.836 56.1553 31.3109C56.5083 30.9958 56.8844 30.8383 57.2847 30.8383C57.8963 30.8383 58.5785 31.219 59.3318 31.9804C59.8965 32.5581 60.6024 33.0044 61.4495 33.3195C62.3197 33.6608 63.2494 33.8315 64.2377 33.8315C66.073 33.8315 67.4963 33.2145 68.5083 31.9804C69.5197 30.7464 70.0022 29.0397 69.9553 26.8604L69.92 25.285C69.1199 26.3353 68.1785 27.1099 67.0965 27.6087C66.0377 28.1076 64.7318 28.357 63.1789 28.357C60.2847 28.357 58.0259 27.4775 56.4024 25.7183C54.7787 23.9328 53.9669 21.4647 53.9669 18.314C53.9669 15.1632 54.7904 12.7082 56.4377 10.949C58.1081 9.16361 60.4259 8.27087 63.3906 8.27087C64.6138 8.27087 65.7906 8.54657 66.92 9.09795C68.0494 9.64934 69.0608 10.4239 69.9553 11.4216V10.634C69.9553 9.89881 70.1671 9.32115 70.5906 8.90103C71.0142 8.48097 71.5789 8.27087 72.2847 8.27087C72.9906 8.27087 73.5432 8.48097 73.9436 8.90103C74.3671 9.29487 74.5789 9.87254 74.5789 10.634V26.8604C74.5789 28.961 74.1669 30.8383 73.3436 32.4924C72.5434 34.1466 71.3787 35.4463 69.8495 36.3915C68.3434 37.3367 66.555 37.8093 64.4847 37.8093ZM64.0965 24.261C65.9318 24.261 67.3667 23.7359 68.4024 22.6856C69.4375 21.6354 69.9553 20.1782 69.9553 18.314C69.9553 16.4498 69.4375 14.9925 68.4024 13.9423C67.3667 12.892 65.9318 12.3669 64.0965 12.3669C62.3787 12.3669 61.0375 12.892 60.073 13.9423C59.1079 14.9925 58.6259 16.4498 58.6259 18.314C58.6259 20.1782 59.1079 21.6354 60.073 22.6856C61.0375 23.7359 62.3787 24.261 64.0965 24.261Z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7604 11.1312C26.4663 11.1312 27.0311 11.3413 27.4546 11.7614C27.8781 12.1815 28.0898 12.7592 28.0898 13.4943V26.4217H28.0847L26.001 30.7263C25.9108 30.9128 25.6402 30.9128 25.55 30.7263L23.4663 26.4217V13.4943C23.4663 12.7592 23.6662 12.1815 24.0663 11.7614C24.4662 11.3413 25.031 11.1312 25.7604 11.1312Z",
    fill: "#FF6E79"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_890_13837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8379 -0.00012207C27.6262 -0.000111188 29.0817 0.894695 29.1316 2.01034C29.1324 2.0322 29.1329 2.05414 29.133 2.07613C29.1329 2.07885 29.1328 2.0816 29.1328 2.08432C29.1328 2.93994 28.6024 3.69823 27.7851 4.16838V6.15973C28.8629 6.61333 29.5825 7.43214 29.5825 8.36693C29.5825 8.36962 29.5823 8.3724 29.5823 8.37509C29.5822 8.3971 29.5818 8.41896 29.5809 8.44082C29.5241 9.55649 27.8701 10.4513 25.8379 10.4513C23.8056 10.4513 22.1516 9.55649 22.0948 8.44082C22.0939 8.41896 22.0934 8.3971 22.0933 8.37509C22.0934 8.3724 22.0936 8.36962 22.0936 8.36693C22.0936 7.43214 22.8128 6.61333 23.8906 6.15973V4.16846C23.0733 3.69831 22.5427 2.93998 22.5426 2.08432C22.5427 2.08785 22.5431 2.09139 22.5432 2.09492C22.5431 2.08867 22.5428 2.08239 22.5427 2.07613C22.5428 2.05414 22.5432 2.0322 22.544 2.01034C22.594 0.894695 24.0495 -0.000113395 25.8379 -0.00012207Z",
    fill: "#FF6E79"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_890_13837",
    x: 21.827,
    y: -0.266406,
    width: 8.55439,
    height: 11.5166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.266284,
    dy: 0.266284
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.266284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.427451 0 0 0 0 0.447059 0 0 0 0 0.501961 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_890_13837"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_890_13837",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.532568,
    dy: -0.133142
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.133142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.643079 0 0 0 0 0.0291351 0 0 0 0 0.0757102 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_890_13837"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.532568,
    dy: 0.133142
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.133142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_890_13837",
    result: "effect3_innerShadow_890_13837"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_890_13837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGray);
export default __webpack_public_path__ + "static/media/Logo_gray.c1b64165ec8995f9ba166210647ab23f.svg";
export { ForwardRef as ReactComponent };